<div #card id="loading-page" aria-label="carregando" role="text" tabindex="0">
    <div aria-hidden="true">
        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin: auto; background: #FFFFFF; display: block;" width="40px" height="40px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
            <circle cx="50" cy="50" fill="none" stroke="#ADAFBD" stroke-width="10" r="37" stroke-dasharray="174.35839227423352 60.119464091411174">
                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1.0526315789473684s" values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
            </circle>
        </svg>
    </div>
  </div>
